import styled from 'styled-components';

export default styled.hr`
  margin-bottom: 0.5rem;
  color: ${(p) => p.theme.colors.primaryDarkGray};
`;
